var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTheFire = function SvgTheFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.455 14c-.152 0-.307-.007-.458-.023A5.513 5.513 0 0 1 .85 11.352C-.598 8.972-.163 5.846 1.907 3.747l.111-.112C3.041 2.599 3.924 1.704 4.446.195A.287.287 0 0 1 4.638.01c.09-.024.182 0 .253.063 2.005 1.847 2.688 4.3 2.412 6.093.79-.62 1.289-1.4 1.691-2.595a.285.285 0 0 1 .225-.194.273.273 0 0 1 .266.12c.99 1.476 1.528 3.146 1.515 4.702a5.975 5.975 0 0 1-.532 2.459c-.916 2-2.93 3.343-5.013 3.343Z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.9
  })));
};
export default SvgTheFire;